import { Component, OnInit, Input, EventEmitter, Output } from "@angular/core";
import {
  RecordingSource,
  RecordingSourceType,
} from "app/js/src/domain/recording-source";

@Component({
  selector: "evrideo-recording-asset-group",
  templateUrl: "./asset-group.component.html",
  styleUrls: ["./asset-group.component.scss"],
})
export class AssetGroupComponent implements OnInit {
  @Input() searchTerm = "";
  @Input() title: string;
  @Input() icon: string;
  @Input() items: Array<RecordingSource> = [];
  @Output() createPreviewFromManager = new EventEmitter<{
    type: RecordingSourceType;
    id: string;
  }>();
  @Output() createRecordingJobFromManager = new EventEmitter<{
    type: RecordingSourceType;
    id: string;
  }>();
  @Output() navigateToSchdulerFromManager = new EventEmitter<string>();

  constructor() {}

  ngOnInit() {}

  getItemsCount() {
    return this.items.length;
  }
  getIcon() {
    return this.icon;
  }
}
